import { Link, useLocation } from 'react-router-dom'
import { useNavItems } from '@/shared/components/layout/navigation/nav-items'
import { COLLECTION_ANCHOR_ATTR } from '@/shared/lib/collection-tab'
import { emitTabRetap } from '@/shared/lib/tab-retap'
import { cn } from '@/shared/lib/utils'

export function BottomNav() {
  const { pathname } = useLocation()
  const items = useNavItems()

  return (
    <nav
      data-app-nav="bottom"
      // Positioned so the Collection canvas, which takes the whole window rather than
      // resizing itself around this bar, paints underneath it.
      className="relative z-10 flex w-full items-center border-t border-app-grey-200 bg-white px-[24px] pt-[10px] lg:hidden"
      style={{ paddingBottom: 'max(8px, env(safe-area-inset-bottom))' }}
    >
      {items.map((item) => {
        const isActive =
          item.path === '/plan'
            ? pathname === '/plan' || pathname.startsWith('/plan/')
            : pathname.startsWith(item.path)
        return (
          <Link
            key={item.path}
            to={item.path}
            onClick={() => {
              if (pathname === item.path) emitTabRetap(item.path)
            }}
            className={cn(
              'flex flex-1 flex-col items-center justify-center rounded-[40px] py-[8px]',
              'transition-colors duration-200',
              isActive
                ? 'bg-app-grey-100 text-app-primary-600'
                : 'text-app-grey-700',
            )}
          >
            {/* One height for every tab; the icon inside keeps the size it was drawn at. */}
            <span className="flex h-5.5 items-center">
              <span
                className="relative inline-flex"
                // The fan measures this to know where to land; only the Collection tab has one.
                {...(item.path === '/collection'
                  ? { [COLLECTION_ANCHOR_ATTR]: true }
                  : {})}
              >
                <item.icon />
                {item.hasDot && (
                  // Anchored to the icon, not the label: the label is a different width in
                  // every language.
                  <span className="absolute -top-[1px] -right-[3px] size-[5px] rounded-full bg-app-error ring-1 ring-white" />
                )}
              </span>
            </span>
            <span
              className={cn(
                'text-xs',
                isActive
                  ? 'font-medium text-app-primary-600'
                  : 'font-normal text-app-grey-800',
              )}
            >
              {item.label}
            </span>
          </Link>
        )
      })}
    </nav>
  )
}
